import type { Data } from '@repo/strapi-types'
import { Tag } from '@/components/elementary/Tag'
import Heading from '@/components/typography/Heading'
import { cn } from '@/lib/styles'

type FeatureCardProps = {
	readonly item: Data.Component<'shared.roadmap-item'>
	readonly variant?: 'primary' | 'secondary'
}

function getCustomColors(tag: NonNullable<Data.Component<'shared.roadmap-item'>['tags']>[number]) {
	if (!tag?.customColors) return undefined
	return {
		backgroundColor: tag.customColors.backgroundColor?.color,
		textColor: tag.customColors.textColor?.color,
		borderColor: tag.customColors.borderColor?.color,
	}
}

export function FeatureCard({ item, variant = 'primary' }: FeatureCardProps) {
	const isSecondary = variant === 'secondary'

	return (
		<div
			className={cn(
				'border border-neutral-light-600 rounded-2xl p-4.5 flex flex-col justify-between gap-5 transition-colors h-full',
				isSecondary ? 'bg-neutral-light-300' : 'bg-white',
			)}
		>
			<Heading tag="h4" fontSize="bodyBoldLarge" className="w-full">
				{item.title}
			</Heading>

			{item.tags && item.tags.length > 0 && (
				<div className="flex flex-wrap gap-2.5">
					{item.tags.map((tag) => {
						if (!tag) return null

						return (
							<Tag
								key={tag.id}
								name={tag.name || ''}
								variant={tag.variant?.variant}
								size={tag.size?.size}
								customColors={getCustomColors(tag)}
							/>
						)
					})}
				</div>
			)}
		</div>
	)
}
